import { render } from "./CargoPropertiesPage.vue?vue&type=template&id=2bda17bf&scoped=true"
import script from "./CargoPropertiesPage.vue?vue&type=script&lang=js"
export * from "./CargoPropertiesPage.vue?vue&type=script&lang=js"

import "./CargoPropertiesPage.vue?vue&type=style&index=0&id=2bda17bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bda17bf"]])

export default __exports__